import { GET_MAP_INFRASTRUCTURE_KEY } from '../../constants/cache';
import { ResponseError } from '../../errors/ResponseError';
import { IGetInfrastructureV4Response } from '../../repositories/infrastructure-caching/entities/get_infrastructure/GetInfrastructureV4Response';
import {
  TGetInfrastructureResponse,
  fetchGetInfrastructure,
} from '../../repositories/infrastructure-caching/v4/get-infrastructure';
import { IApplicationContext } from '../../types/applicationContext';
import { TInfrastructureBbox } from '../../types/map';
import { cacheUtils } from '../../utils/cache';
import { convertBboxToString } from '../../utils/convertBboxToString';

export async function getMapInfrastructure({ httpApi, logger }: IApplicationContext, bbox: TInfrastructureBbox) {
  const parameters = {
    bbox: convertBboxToString(bbox),
  };

  try {
    const cacheKey = `${GET_MAP_INFRASTRUCTURE_KEY}_${parameters.bbox}`;
    const cachedData = cacheUtils.getCachedData<IGetInfrastructureV4Response>(cacheKey);
    if (cachedData) {
      return cachedData;
    }
    const { response, statusCode }: TGetInfrastructureResponse = await fetchGetInfrastructure({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'getInfrastructure',
        message: response.message || '',
        details: {
          error: JSON.stringify(response.errors),
        },
      });
    }

    cacheUtils.setCachedData<IGetInfrastructureV4Response>(cacheKey, response);

    return response;
  } catch (error) {
    logger.error(error, { domain: 'getInfrastructure' });

    throw error;
  }
}
